import { FC } from 'react';
import { SvgProps } from './domain';

const ArrowRight: FC<SvgProps> = ({ className }) => (
  <svg
    className={className}
    viewBox='0 0 31 31'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20.8882 14.2083L13.9597 7.27981L15.7863 5.45312L25.8332 15.5L15.7863 25.5467L13.9597 23.72L20.8882 16.7917H5.1665V14.2083H20.8882Z'
      fill='url(#paint0_linear_1796_459)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_1796_459'
        x1='15.4998'
        y1='5.45312'
        x2='15.4998'
        y2='25.5467'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#006FFF' />
        <stop offset='1' stopColor='#00D2A4' />
      </linearGradient>
    </defs>
  </svg>
);

export default ArrowRight;
